import {gql} from '@apollo/client';

// Interface representing returned data from API
export interface ApiAuth {
	id: string

	user?: {
		id: string

		referrals: {
			referrable: boolean
		}

		txns: {
			edges: {
				node: {
					details: {
						reason: string
					}
				}
			}[]
		}
	}
}

export const checkFirstPurchase = (user: ApiAuth['user']) => {
	const txns = user?.txns.edges || [];
	for (const txn of txns) {
		if (txn.node.details.reason === 'Purchased') {
			return false;
		}
	}
	return true;
};

// Fragment to enable query composability
export const API_AUTH = gql`
fragment ApiAuth on Auth {
	id

	user {
		id

		referrals {
			id
			referrable(referrer: $referrer)
		}

		txns(page: {first: 10}) {
			edges {
				node {
					id
					details {
						id
						reason
					}
				}
			}
		}
	}
}`;
